import React from "react";
import { CustomColorTokens } from "src/constants/customColorTokens";
import { videoScreenViewMode } from "src/jobRotationAssessment/constants/jobRotationConstants";
import { useAppSelector } from "src/store/store";
const { BRAND_WHITE, BRAND_DARK_GREY } = CustomColorTokens;
export interface Segment {
  startTimeInSeconds: number;
  endTimeInSeconds: number;
}
interface SegmentPainterProps {
  segment: Segment;
  videoRef: React.MutableRefObject<HTMLVideoElement | null>;
  isHighlighted: boolean;
}
const SegmentPainter = ({
  segment,
  videoRef,
  isHighlighted,
}: SegmentPainterProps) => {
  const { videoViewMode } = useAppSelector(
    (state) => state.createJobRotationAssessment
  );
  const getSegmentStyle = (segment: {
    startTimeInSeconds: number;
    endTimeInSeconds: number;
  }) => {
    if (videoRef.current) {
      const scrubberPercentage = 96;
      const scrubberOffset = (100 - scrubberPercentage) / 2;
      const scrubberWidthScale = scrubberPercentage / 100;
      const startPercent =
        scrubberOffset +
        (segment.startTimeInSeconds / videoRef.current.duration) *
          scrubberWidthScale *
          100;
      const widthPercent =
        ((segment.endTimeInSeconds - segment.startTimeInSeconds) /
          videoRef.current.duration) *
        scrubberWidthScale *
        100;
      return {
        height:
          videoViewMode === videoScreenViewMode.SMALL_VIEW ? "8px" : "14px",
        left: `${startPercent}%`,
        bottom:
          videoViewMode === videoScreenViewMode.SMALL_VIEW
            ? "20px"
            : isHighlighted
            ? "15px"
            : "17px",

        width: `${widthPercent}%`,
        border: isHighlighted ? `2px solid ${BRAND_WHITE}` : "none",
        opacity: isHighlighted ? 0.6 : 1,
        background: isHighlighted ? BRAND_DARK_GREY : BRAND_WHITE,
      };
    }
  };
  return (
    <div
      style={{
        ...getSegmentStyle(segment),
        position: "absolute",
        borderRadius: "5px",
        pointerEvents: "none",
        zIndex: isHighlighted ? 2 : 1,
      }}
    />
  );
};

export default SegmentPainter;
